import { request } from './api';

declare global {
  interface Window {
    Brevo?: any;
  }
}

export function brevoDateNow(): string {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function brevoIdentify(email: string, attrs?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.Brevo) return;

  const payload: Record<string, unknown> = {
    identifiers: { email_id: email },
  };
  if (attrs) payload.attributes = attrs;

  window.Brevo.push(function () {
    window.Brevo!.identify(payload);
  });
}

export function brevoTrack(event: string, data?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.Brevo) return;

  window.Brevo.push(function () {
    window.Brevo!.track(event, undefined, data);
  });
}

export function requestBrevo(url: string, data: Record<string, unknown>) {
  return request(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
